// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* KYC.module.css */

.container {
  min-height: 100vh;
  background: var(--background);
  padding: 16px;
}

.content {
  width: 100%;
  max-width: 600px;
  margin: auto;
  background: var(--background);
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.10);
  padding: 32px 18px;
}

.title {
  margin-bottom: 18px;
  color: var(--foreground);
  font-weight: 700;
  font-size: 1.5rem;
}

.loading {
  color: var(--muted-foreground);
}

.error {
  color: var(--danger);
}

.status {
  font-weight: 500;
  color: var(--info);
  margin-bottom: 8px;
  font-size: 1.1rem;
}

.statusValue {
  color: var(--foreground);
}

.remarks {
  color: var(--muted-foreground);
}

.documentLink {
  color: var(--info);
  font-weight: 500;
  text-decoration: none;
}

.uploadForm {
  margin-top: 20px;
}

.fileInput {
  margin-right: 10px;
  width: 100%;
}

.uploadButton {
  background: var(--info);
  color: var(--background);
  border: none;
  border-radius: 6px;
  padding: 8px 18px;
  font-weight: 600;
  cursor: pointer;
  font-size: 15px;
  box-shadow: 0 2px 8px rgba(var(--info-rgb), 0.08);
  width: 100%;
}

.uploadButton:disabled {
  cursor: not-allowed;
}

.uploadError {
  color: var(--danger);
  margin-top: 8px;
}

.success {
  color: var(--success);
  margin-top: 8px;
}

/* Media queries */
@media (max-width: 480px) {
  .content {
    padding: 18px 8px !important;
    border-radius: 8px !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  }
  .title {
    font-size: 1.1rem !important;
  }
  .uploadButton, .fileInput {
    font-size: 1rem !important;
    padding: 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/KYC.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE;IACE,4BAA4B;IAC5B,6BAA6B;IAC7B,oDAAoD;EACtD;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;AACF","sourcesContent":["/* KYC.module.css */\n\n.container {\n  min-height: 100vh;\n  background: var(--background);\n  padding: 16px;\n}\n\n.content {\n  width: 100%;\n  max-width: 600px;\n  margin: auto;\n  background: var(--background);\n  border-radius: 12px;\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.10);\n  padding: 32px 18px;\n}\n\n.title {\n  margin-bottom: 18px;\n  color: var(--foreground);\n  font-weight: 700;\n  font-size: 1.5rem;\n}\n\n.loading {\n  color: var(--muted-foreground);\n}\n\n.error {\n  color: var(--danger);\n}\n\n.status {\n  font-weight: 500;\n  color: var(--info);\n  margin-bottom: 8px;\n  font-size: 1.1rem;\n}\n\n.statusValue {\n  color: var(--foreground);\n}\n\n.remarks {\n  color: var(--muted-foreground);\n}\n\n.documentLink {\n  color: var(--info);\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.uploadForm {\n  margin-top: 20px;\n}\n\n.fileInput {\n  margin-right: 10px;\n  width: 100%;\n}\n\n.uploadButton {\n  background: var(--info);\n  color: var(--background);\n  border: none;\n  border-radius: 6px;\n  padding: 8px 18px;\n  font-weight: 600;\n  cursor: pointer;\n  font-size: 15px;\n  box-shadow: 0 2px 8px rgba(var(--info-rgb), 0.08);\n  width: 100%;\n}\n\n.uploadButton:disabled {\n  cursor: not-allowed;\n}\n\n.uploadError {\n  color: var(--danger);\n  margin-top: 8px;\n}\n\n.success {\n  color: var(--success);\n  margin-top: 8px;\n}\n\n/* Media queries */\n@media (max-width: 480px) {\n  .content {\n    padding: 18px 8px !important;\n    border-radius: 8px !important;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;\n  }\n  .title {\n    font-size: 1.1rem !important;\n  }\n  .uploadButton, .fileInput {\n    font-size: 1rem !important;\n    padding: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
